import React, { useState } from 'react';
import ClinicLayout from './ClinicLayout';
import { Eye } from 'lucide-react';

const ClinicPatientPortal = () => {
  const [activeSubTab, setActiveSubTab] = useState('messages');
  const [messages] = useState([]);

  return (
    <ClinicLayout activeTab="patient-portal">
      <div className="p-4 pr-20" data-testid="clinic-patient-portal">
        {/* Sub Navigation Tabs */}
        <div className="flex items-center justify-end mb-2">
          <div className="flex items-center gap-4 text-xs">
            <span 
              className={`cursor-pointer hover:underline ${activeSubTab === 'virtual' ? 'font-medium' : 'text-[#2563eb]'}`}
              onClick={() => setActiveSubTab('virtual')}
            >
              Virtual Visits
            </span>
            <span 
              className={`cursor-pointer hover:underline ${activeSubTab === 'messages' ? 'font-medium' : 'text-[#2563eb]'}`}
              onClick={() => setActiveSubTab('messages')}
            >
              Patient Messages
            </span>
            <span 
              className={`cursor-pointer hover:underline ${activeSubTab === 'appointments' ? 'font-medium' : 'text-[#2563eb]'}`}
              onClick={() => setActiveSubTab('appointments')}
            >
              Appointments
            </span>
          </div>
        </div>

        {/* Section Header */}
        <div className="bg-gradient-to-b from-[#4a5568] to-[#2d3748] text-white px-3 py-2 text-sm font-medium mb-4">
          Patient Messages
        </div>

        {/* Filters */}
        <div className="bg-[#f5f5f5] border border-gray-300 p-3 mb-4">
          <div className="flex items-center gap-4 text-xs">
            <div className="flex items-center gap-2">
              <label>Search:</label>
              <input type="text" className="border border-gray-400 px-1 py-0.5 w-40" />
            </div>
            <div className="flex items-center gap-2">
              <label>Provider:</label>
              <select className="border border-gray-400 px-1 py-0.5">
                <option>No PatientAlly Providers</option>
              </select>
            </div>
            <div className="flex items-center gap-2">
              <label>Status:</label>
              <select className="border border-gray-400 px-1 py-0.5">
                <option>All</option>
                <option>Unread</option>
                <option>Read</option>
              </select>
            </div>
            <div className="flex-1"></div>
            <button className="border border-gray-300 px-3 py-0.5 bg-gray-200 text-gray-500 cursor-not-allowed">
              Compose New
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="border border-gray-300">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-[#1e3a5f] text-white">
                <th className="p-1 border border-gray-400 text-left">Subject</th>
                <th className="p-1 border border-gray-400 text-left">From</th>
                <th className="p-1 border border-gray-400 text-left">To</th>
                <th className="p-1 border border-gray-400 text-left">Last Message On</th>
                <th className="p-1 border border-gray-400 text-center">View</th>
              </tr>
            </thead>
            <tbody>
              {messages.length === 0 ? (
                <tr>
                  <td colSpan="5" className="p-8 text-center text-gray-500">
                    
                  </td>
                </tr>
              ) : (
                messages.map((msg, index) => (
                  <tr key={msg.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    <td className="p-1 border border-gray-300 text-[#2563eb] cursor-pointer hover:underline">{msg.subject}</td>
                    <td className="p-1 border border-gray-300">{msg.from}</td>
                    <td className="p-1 border border-gray-300">{msg.to}</td>
                    <td className="p-1 border border-gray-300">{msg.lastMessageOn}</td>
                    <td className="p-1 border border-gray-300 text-center">
                      <Eye className="w-3 h-3 inline cursor-pointer text-gray-600" />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="mt-3 flex items-center justify-center gap-2 text-xs">
          <span>|◀ ◀◀</span>
          <span>Page</span>
          <input type="text" className="border border-gray-400 w-8 text-center" defaultValue="1" />
          <span>of 0</span>
          <span>▶▶ ▶|</span>
          <select className="border border-gray-400 px-1">
            <option>20</option>
          </select>
        </div>
      </div>
    </ClinicLayout>
  );
};

export default ClinicPatientPortal;
